<template>
  <div>
    <div class="inmate-box">
      <img
        class="inmate-image"
        @click="openInmateProfile"
        v-if="Inmate.photo"
        :src="'data:image/jpg;base64,' + Inmate.photo"
      />
      <img
        v-else
        src="../../public/MissingInmateImage.png"
        class="inmate-image"
        @click="openInmateProfile"
      />
    </div>
    <div class="inmate-info">
      <!-- 
       <div class="info-title">Name</div>
      
       {{Inmate.name}}

      <br />

      <div class="info-title">Age</div>
       
      {{Inmate.age}} 

      <br />

      <div class="info-title">Status</div>

      {{Inmate.status}}

      <br />

      <div class="info-title">Booked</div>

      {{Inmate.bookDate}} -->

      <div class="inmate-name" @click="openInmateProfile">
        {{ Inmate.inmateLast }}, {{ Inmate.inmateFirst }}
      </div>
      <!-- <b>Inmate ID:</b> {{Inmate.inmateId}}
      <br />
      <b>Date of Birth:</b> {{Inmate.dob}}
      <br />
      <b>Booking ID:</b> {{Inmate.bookingId}}
      <br />
      <b>Booking Date:</b> {{Inmate.bookingDate}}
      <br />
      <b>Scheduled Releassade Date:</b> {{Inmate.scheduledReleaseDate}}
      <br />
      <b>Arresting Agency:</b> {{Inmate.arrestingAgency}}
      <br />
      <b>Release Date:</b> {{Inmate.releaseDate}} 
      <br />
      <b>Class Location:</b> {{Inmate.classLocation}}   -->

      <table class="inmate-box-data">
        <tr>
          <td>Date of Birth:</td>
          <td>{{ Inmate.birthDate }}</td>
        </tr>
        <!-- <tr>
          <td>Inmate ID:</td>
          <td>{{ Inmate.inmateId }}</td>
        </tr> -->
        <tr>
          <td>Booking ID:</td>
          <td>{{ Inmate.bookingId }}</td>
        </tr>
        <tr>
          <td>Status:</td>
          <td>{{ Inmate.inmateStatus }}</td>
        </tr>
        <tr>
          <td>Booking Date:</td>
          <td>{{ Inmate.bookingDate }}</td>
        </tr>
        <tr>
          <td>Scheduled Release Date:</td>
          <td>{{ Inmate.scheduledReleaseDate }}</td>
        </tr>
        <tr>
          <td>Arresting Agency:</td>
          <td>{{ Inmate.arrestAgency }}</td>
        </tr>
        <tr>
          <td>Release Date:</td>
          <td>{{ Inmate.releaseDate }}</td>
        </tr>
        <tr>
          <td>Facility:</td>
          <td>{{ Inmate.assignedFacilityId }}</td>
        </tr>
         <tr>
          <td>Charge Description:</td>
          <td>{{ Inmate.inmateFirstChargeDescription }}</td>
        </tr>
      </table>
      <!-- 
        Name
        Inmate ID
        Date of Birth
        Booking #
        Booking Date
        Arresting Agency
        Release Date
        POD Location
      -->
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main.js";

export default {
  props: ["Inmate"],
  data() {
    return {};
  },
  // computed: {
  //   image() {
  //     return "../assets/" + this.Inmate.image;
  //   }
  // },
  methods: {
    openInmateProfile() {
      //DEVELOPMENT
      // console.log(this.Inmate.name);
      this.$store.state.inmate = this.Inmate;
      this.$nextTick(() => {
        eventBus.$emit("loadInmateBreakdown");
      });
      if (window.innerWidth >= 1336) {
        window.scrollTo(0, 300);
      } else if (window.innerWidth > 1000) {
        window.scrollTo(0, 382);
      } else if (window.innerWidth >= 720) {
        window.scrollTo(0, 366);
      } else if (window.innerWidth >= 676) {
        window.scrollTo(0, 380);
      } else if (window.innerWidth >= 456) {
        window.scrollTo(0, 520);
      } else {
        window.scrollTo(0, 840);
      }
    },
    // General Utility Methods

    // Call this to open the modal window after setting the values in the store
    modalOpen() {
      this.$nextTick(() => {
        eventBus.$emit("openModalWindow");
      });
    },

    // Run this before OR after each use of the modal window (use the same choice for every use of the modal window)
    resetModalWindow() {
      eventBus.$emit("clearModalData");
    },
  },
  created() {
    // document.getElementById("inmate-image").src = "../../public/" + this.Inmate.image
  },
};
</script>

<style>
.inmate-image {
  max-width: 300px;
  max-height: 300px;
  /* min-height: 300px; */
  /* margin-top: 40px; */
  /* border: 1px solid black; */

  margin: auto;
  cursor: pointer;
  /* vertical-align: center; */
  /* overflow: hidden; */
}

.inmate-box {
  margin: auto;
  margin-top: 40px;
  height: 300px;
  width: 300px;
  /* background-color: black; */
  /* vertical-align: center; */
  /* text-align: center; */
  display: flex;
  justify-content: center;
}

.inmate-info {
  width: 450px;
  text-align: left;
  /* padding-left: 20px; */
  /* padding-left: 50px; */
  /* padding-left: 50px; */
  /* margin-top: 20px; */
}

.info-title {
  font-weight: bold;
  font-size: 20px;
  display: block;
  text-decoration: underline;
  text-align: center;
  margin-top: 7px;
  margin-bottom: 2px;
}

.inmate-name {
  font-size: 28px;
  text-align: center;
  color: rgb(18, 27, 102);
  margin: 5px 0;
}

.inmate-name:hover {
  text-decoration: underline;
  cursor: pointer;
  color: rgb(68, 87, 152);
}

.inmate-image {
  border: 1px solid black;
}

.inmate-box-data tr td:first-child {
  font-weight: bold;
  text-align: right;
}

.inmate-box-data tr * {
  width: auto;
}

.inmate-box-data {
  margin: auto;
}
</style>